"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFinalTaskState = void 0;
const index_js_1 = require("../lib/status/types/index.js");
const isFinalTaskState = (taskState) => {
    switch (taskState) {
        case index_js_1.TaskState.ExecSuccess:
        case index_js_1.TaskState.ExecReverted:
        case index_js_1.TaskState.Cancelled:
            return true;
        default:
            return false;
    }
};
exports.isFinalTaskState = isFinalTaskState;
